import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SimplePaginator } from './models/simple-paginator.interfaces';

@Component({
  selector: 'idp-simple-paginator',
  templateUrl: './simple-paginator.component.html',
  styleUrls: ['./simple-paginator.component.scss']
})
export class SimplePaginatorComponent {
  @Input() content: SimplePaginator = {} as SimplePaginator;
  @Output() current: EventEmitter<number> = new EventEmitter<number>();

  validatePrevious(current: number): number {
    if (current == 1) return 1;
    return current - 1;
  }

  validateNext(current: number, total: number): number {
    if (current == total) return current;
    return current + 1;
  }

  calculate(operation: string, current: number, total: number): number {
    let destination = operation === '-' ? this.validatePrevious(current) : 0;
    destination =
      operation === '+' ? this.validateNext(current, total) : destination;
    return destination;
  }

  move(operation: string) {
    const destination = this.calculate(
      operation,
      this.content.current,
      this.content.total
    );
    this.content.current = destination;
    this.content.label = this.content.label.replace(
      /\d+(?=\/)/,
      `${destination}`
    );
    // If the accessibility message is different then we need to get the message and assign here
    this.content.ariaLabels.indicator = this.content.label;
    this.current.emit(destination);
  }
}
